module.exports = {
          srcSet: __webpack_public_path__ + "2d564879084fa79faabb1dcdf33a472d-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "2d564879084fa79faabb1dcdf33a472d-2336.png",width: 2336,height: 468}],
          src: __webpack_public_path__ + "2d564879084fa79faabb1dcdf33a472d-2336.png",
          toString:function(){return __webpack_public_path__ + "2d564879084fa79faabb1dcdf33a472d-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AF2Q/v1YjP7/SYL+/kl7/v8yZP3+K17//n115f99duv+b37d/zlc9/sAO5f//Uya/v9Plf7+Q4n+/zZ6/v9Dffz+UHv9/1Ru6/5pfN3/KlL9+8AqNtO5xX0nAAAAAElFTkSuQmCC",
          width: 2336,
          height: 468
        }